import ZonePricetype from './ZonePricetype';
import AmountInput from './AmountInput';
import ControlGroup from '../../tnew/lib/ControlGroup';
import dom from '../../utils/dom';
import FormFieldsComponent from './components/FormFieldsComponent';


class EditableZonePriceType extends ZonePricetype {
  /**
   * @param {HTMLElement} $el
   */
  constructor($el) {
    super($el);

    this.$select.addEventListener('blur', this.updateFeedback);
    this.$select.addEventListener('change', this.onQuantityChange);

    /** @type {HTMLInputElement} */
    const $amountInput = dom.findFrom($el, '.tn-ticket-selector__custom-amount-input');

    this.controlGroup = new ControlGroup($el, $amountInput.id);

    this.amount = new AmountInput($amountInput);

    this.amount.addEventListener('input', this.onAmountChange);
    this.amount.addEventListener('blur', this.updateFeedback);
  }

  onQuantityChange = () => {
    const quantity = this.getQuantity();

    this.amount.setIsRequired(quantity > 0);

    this.updateFeedback();

    this.emit('quantity-change');
  }

  onAmountChange = () => {
    const amount = this.amount.getState();

    if (amount.isValid) {
      this.controlGroup.clearErrors();
    }

    this.emit('price-change');
  }


  updateFeedback = () => {
    const amount = this.amount.getState();

    if (amount.isValid) {
      this.controlGroup.clearErrors();
      return;
    }

    if (amount.badInput) {
      this.controlGroup.showError(FormFieldsComponent.decimalValidationMessage);
      return;
    }

    if (amount.valueMissing) {
      this.controlGroup.showError(FormFieldsComponent.requiredFieldValidationMessage);
      return;
    }

    if (amount.rangeUnderflow) {
      this.controlGroup.showError(FormFieldsComponent.contributionMinimumValidationMessage);
    }
  }

  getIsPriceValid() { // TODO rename to something like 'can checkout'?
    const quantity = this.getQuantity();

    if (quantity === 0) {
      return true;
    }

    return this.amount.getState().isValid;
  }

  /** @returns {import('./TicketSelector').PriceTypeQuantity} */
  getData() {
    return {
      pricetypeId: this.id,
      isUserPrice: true,
      price: this.amount.getState().value,
      quantity: this.getQuantity(),
    };
  }

  destroy() {
    this.removeAllListeners();

    this.$select.removeEventListener('blur', this.updateFeedback);
    this.$select.removeEventListener('change', this.onQuantityChange);

    this.amount.removeEventListener('input', this.onAmountChange);
    this.amount.removeEventListener('blur', this.updateFeedback);
  }
}


export default EditableZonePriceType;



// WEBPACK FOOTER //
// ./src/events/detail/EditableZonePriceType.js